import { LoadingIndicator } from "@dealer-center/core-custom-components";
import ResultsTabs from "./ResultsTabs";
import AdvancedFiltersContainer from "./AdvancedFiltersContainer";

import { FailureState } from "@dealer-center/core-errors";
import {
  useGetAccountEvents,
  useGetAccountProviders
} from "@dealer-center/ddc-pages-inventory-archiver-fetch";
import type { ResultsContainerProps } from "@dealer-center/ddc-pages-inventory-archiver-interface";

/**
 * Inventory Feed Results component
 * @constructor
 */

const ResultsContainer = (props: ResultsContainerProps) => {
  const account = props.account || "";
  const {
    data: providersData,
    error: providersError,
    isLoading: isProvidersLoading
  } = useGetAccountProviders(account);

  const {
    data: eventsData,
    error: eventsError,
    isLoading: isEventsLoading
  } = useGetAccountEvents(account, providersData);

  if (providersError)
    return (
      <FailureState
        error={
          new Error(` Error fetching providers: ${providersError.message}`)
        }
      />
    );
  else if (eventsError)
    return (
      <FailureState
        error={new Error(` Error fetching events: ${eventsError.message}`)}
      />
    );
  else if (isProvidersLoading || isEventsLoading)
    return (
      <LoadingIndicator
        actionName={"Loading Account Data"}
        text={`Getting Data for ID: ${account}...`}
      />
    );
  return (
    <>
      <AdvancedFiltersContainer
        providers={Array.isArray(providersData) ? providersData : []}
      />
      <ResultsTabs data={eventsData} />
    </>
  );
};

export default ResultsContainer;
